import { render, staticRenderFns } from "./Build.vue?vue&type=template&id=2df31dfc&"
import script from "./Build.vue?vue&type=script&lang=js&"
export * from "./Build.vue?vue&type=script&lang=js&"
import style0 from "./Build.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports